<template>
  <div>
    <h2 class="font-semibold uppercase text-gray-600">
      Edit Vehicle
    </h2>
    <form @submit.prevent="edit" class="w-full max-w-2xl">
      <label class="block mt-4">
        <span class="text-gray-700">Vehicle Type</span>
        <select @change="setVehicleType" class="form-select mt-1 block w-full">
          <option value="">Select a vehicle type</option>
          <option
            v-for="vehicleType in vehicleTypes"
            :value="vehicleType._id"
            :key="`vt-opt-${vehicleType._id}`"
            :selected="vehicle.vehicleType === vehicleType._id"
          >
            {{ vehicleType.name }}
          </option>
        </select>
      </label>
      <label class="block mt-4">
        <span class="text-gray-700">Model</span>
        <input
          v-model="vehicle.modelName"
          class="form-input mt-1 w-full block"
          placeholder="Yaris"
        />
      </label>
      <label class="block mt-4">
        <span class="text-gray-700">Year</span>
        <input
          v-model="vehicle.modelYear"
          class="form-input mt-1 w-full block"
          placeholder="2009"
        />
      </label>
      <label class="block mt-4">
        <span class="text-gray-700">Plate Number</span>
        <input
          v-model="vehicle.plateNumber"
          class="form-input mt-1 w-full block"
          placeholder="3-AA-XXXXXX"
        />
      </label>
      <label class="block mt-4">
        <span class="text-gray-700">Color</span>
        <input
          v-model="vehicle.color"
          class="form-input mt-1 w-full block"
          placeholder="Teal"
        />
      </label>
      <div class="mt-4">
        <photo-uploader v-model="vehicle.photo" label="Registration" />
      </div>
      <div class="mt-4">
        <photo-uploader v-model="vehicle.libre" label="Registration" />
      </div>
      <div class="mt-4">
        <photo-uploader
          v-model="vehicle.insurance"
          label="3rd Party Insurance"
        />
      </div>
      <div class="relative mt-4">
        <label class="block">
          <span class="text-gray-700">Driver</span>
          <input
            v-model="selectedDriver"
            @keyup="searchDriver"
            class="form-input mt-1 w-full block"
            placeholder="Search drivers..."
          />
        </label>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <div
            v-if="driverSearchResults.length"
            class="absolute bottom-0 inset-x-0 mb-12"
          >
            <div
              class="max-h-64 py-2 bg-white shadow rounded-md overflow-y-auto"
            >
              <ul>
                <li
                  v-for="(result, index) in driverSearchResults"
                  :key="result._id"
                  @click="selectDriver(index)"
                  class="flex items-center space-x-2 px-4 py-2 hover:bg-gray-200 cursor-pointer border-t"
                >
                  <img
                    class="h-12 w-12 rounded-full object-cover"
                    :src="result.profileImage"
                    :alt="`${result.firstName} ${result.lastName}`"
                  />
                  <div>
                    <p>{{ `${result.firstName} ${result.lastName}` }}</p>
                    <p class="text-gray-600 text-sm font-semibold">
                      {{ result.phoneNumber }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
      <div class="mt-4">
        <button
          :disabled="busy"
          class="px-4 py-2 text-white font-semibold rounded"
          :class="{
            'bg-blue-200 cursor-not-allowed': busy,
            'bg-blue-500 hover:bg-blue-700': !busy,
          }"
        >
          Edit Vehicle
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import PhotoUploader from "@/components/PhotoUploader.vue";

export default {
  components: {
    PhotoUploader,
  },
  data() {
    return {
      busy: false,
      vehicleTypes: [],
      vehicle: {
        modelYear: "",
        modelName: "",
        color: "",
        libre: "",
        insurance: "",
        plateNumber: "",
        vehicleType: "",
        driver: "",
        photo: "",
      },
      selectedDriver: "",
      drivers: [],
      driverSearchResults: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    this.$http
      .get(`/vehicles/${this.id}`)
      .then(response => (this.vehicle = response.data))
      .catch(err => console.log(err));

    this.$http
      .get("vehicleTypes")
      .then(response => (this.vehicleTypes = response.data.data))
      .catch(err => console.log(err));

    this.$http
      .get("drivers")
      .then(response => (this.drivers = response.data.data))
      .catch(err => console.log(err));
  },
  methods: {
    setVehicleType(e) {
      this.vehicle.vehicleType = e.target.value;
    },
    edit() {
      this.busy = true;
      this.$http
        .patch(`vehicles/${this.id}`, this.vehicle)
        .then(() => {
          window.flash({
            body: "Vehicle edited successfully!",
            type: "success",
          });
          this.$router.push("/vehicles");
        })
        .catch(err => {
          window.flash({ body: "Failed to edit vehicle!", type: "error" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
    searchDriver(e) {
      if (e.target.value.trim() === "") {
        this.driverSearchResults = [];
      } else if (!isNaN(parseInt(e.target.value))) {
        this.driverSearchResults = this.drivers.filter(driver => {
          return driver.phoneNumber.slice(-4).includes(e.target.value);
        });
      } else {
        this.driverSearchResults = this.drivers.filter(driver => {
          let name = driver.firstName + " " + driver.lastName;
          return name.toLowerCase().includes(e.target.value.toLowerCase());
        });
      }
    },
    selectDriver(index) {
      let driver = this.driverSearchResults[index];
      this.selectedDriver = `${driver.firstName} ${driver.lastName} - ${driver.phoneNumber}`;
      this.vehicle.driver = driver._id;
      this.driverSearchResults = [];
    },
  },
};
</script>
